import type { MachineInfo } from '@niuma/protocol';

interface Props {
  machines: MachineInfo[];
  selectedId: string | null;
  onSelect: (machineId: string) => void;
}

/** Horizontal machine selector showing online state and capabilities. */
export function MachineSwitcher({ machines, selectedId, onSelect }: Props): JSX.Element {
  if (machines.length === 0) {
    return <div className="empty">No machines connected. Start a runner to register one.</div>;
  }
  return (
    <div className="machine-switcher">
      {machines.map((machine) => (
        <button
          key={machine.id}
          className={`machine-chip ${machine.id === selectedId ? 'active' : ''}`}
          onClick={() => onSelect(machine.id)}
        >
          <span className="machine-head">
            <span className={`dot ${machine.online ? 'online' : 'offline'}`} />
            <span className="machine-name">{machine.name}</span>
          </span>
          <span className="machine-caps">{machine.capabilities.join(' · ')}</span>
        </button>
      ))}
    </div>
  );
}
